import { render, staticRenderFns } from "./SetPasswordSuccess.vue?vue&type=template&id=44664fae&scoped=true&"
import script from "./SetPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./SetPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SetPasswordSuccess.vue?vue&type=style&index=0&id=44664fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44664fae",
  null
  
)

export default component.exports